import Swal from 'sweetalert2';
import { IFormData } from '../../../pages/LoginPage/interface';
import cabine from '../../../services/cabineApi';
import { loginAction } from '../../duck/loginPage/loginAuth';

function authLogin(user: IFormData) {
  return (dispatch: any) => {
    cabine
      .post('/v1/login', user)
      .then((response: any) => {
        localStorage.setItem('loginToken', response.data.token);
        dispatch(loginAction(response.data.token));
      })
      .catch((error: any) => {
        if (error.message === 'Request failed with status code 401') {
          Swal.fire({
            title: 'Acesso negado!',
            text: 'Usuário ou senha incorreta',
            icon: 'warning',
            confirmButtonText: 'Tentar novamente',
          });
        } else {
          Swal.fire({
            title: 'Erro!',
            text: 'Tente novamente mais tarde!',
            icon: 'error',
            confirmButtonText: 'Tentar novamente',
          });
        }
      });
  };
}

export default authLogin;
